import { Form, Alert } from 'react-bootstrap';

export type RetainerUploadComponentProps = {
    setRetainerState: (arg0: {
        retainerRequired: any;
        defaultRetainerRequired: any;
        textBoxRetainerRequired: any;
        uploadRetainer: boolean;
        textBasedRetainer: null;
    }) => void;
    setUploadedFile: (arg0: File) => void;
    retainerState: {
        retainerRequired: boolean;
        textBoxRetainerRequired: boolean;
        uploadRetainer: any;
        defaultRetainerRequired: any;
        textBasedRetainer: any;
    };
}

const RetainerUploadComponent = (props: RetainerUploadComponentProps) => {

    const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        const files = Array.from(e.target.files);
        let uploadedFile: File;
        if (files) {
            uploadedFile = files[0];
            if (uploadedFile) {
                props.setRetainerState({
                    retainerRequired: true,
                    defaultRetainerRequired: false,
                    textBoxRetainerRequired: false,
                    uploadRetainer: true,
                    textBasedRetainer: null
                })
                props.setUploadedFile(uploadedFile)
            }
        }
    }

    const handleRequireRetainer = (e) => {
        props.setRetainerState({
            retainerRequired: e.target.checked,
            defaultRetainerRequired: false,
            textBoxRetainerRequired: false,
            uploadRetainer: false,
            textBasedRetainer: null
        });
    }

    // const handleRequireDefaultRetainer = (e) => {
    //     props.setRetainerState({
    //         retainerRequired: true,
    //         defaultRetainerRequired: e.target.checked,
    //         textBoxRetainerRequired: false,
    //         uploadRetainer: false,
    //         textBasedRetainer: null
    //     })
    // }

    const handleTextBoxRetainerRequired = (e) => {
        props.setRetainerState({
            retainerRequired: true,
            defaultRetainerRequired: false,
            textBoxRetainerRequired: e.target.checked,
            uploadRetainer: false,
            textBasedRetainer: null
        })
    }

    const handleTextBoxChange = (e) => {
        props.setRetainerState({
            ...props.retainerState,
            textBasedRetainer: e.target.value
        })
    }

    // const defaultRetainerCase = () => {
    //     return props.retainerState.retainerRequired && !props.retainerState.textBoxRetainerRequired && !props.retainerState.uploadRetainer;
    // }

    const textBoxRetainerCase = () => {
        return props.retainerState.retainerRequired && !props.retainerState.defaultRetainerRequired && !props.retainerState.uploadRetainer;
    }

    const uploadRetainerCase = () => {
        return props.retainerState.retainerRequired && !props.retainerState.defaultRetainerRequired && !props.retainerState.textBoxRetainerRequired;
    }


    return (
        <>
            <h3>Add Written Retainer</h3>
            <Alert className="mb-3"><b>Optionally</b> upload or enter a retainer.</Alert>

            <Form.Check
                type="checkbox"
                checked={props.retainerState.retainerRequired}
                // defaultChecked={props.retainerState.retainerRequired}
                label="Require Written Retainer"
                onChange={(e) => { handleRequireRetainer(e) }}
            />
            {/* {defaultRetainerCase() ? <>
                <Form.Check
                    type="checkbox"
                    disabled
                    checked={props.retainerState.defaultRetainerRequired}
                    label="Use Default Retainer"
                    onClick={(e) => { handleRequireDefaultRetainer(e) }}
                />
            </> : null} */}

            {textBoxRetainerCase() ? <>
                <Form.Check
                    type="checkbox"
                    checked={props.retainerState.textBoxRetainerRequired}
                    // defaultChecked={props.retainerState.textBoxRetainerRequired}
                    label="Write Retainer in Text Box"
                    onChange={(e) => { handleTextBoxRetainerRequired(e) }}
                />
                {props.retainerState.textBoxRetainerRequired ? <> <br />
                    <textarea
                        className="form-control"
                        rows={5}
                        placeholder={'Enter retainer text here...'}
                        id='textBasedRetainer'
                        value={props.retainerState.textBasedRetainer ?? ''}
                        onChange={(e) => handleTextBoxChange(e)}
                    />
                </> : null}
            </> : null}

            {uploadRetainerCase() ?
                <Form.Group>
                    <Form.Label className="mt-3">Upload Retainer</Form.Label>
                    <Form.Control
                        className="form-upload"
                        type="file"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleFileUpload(e); }}
                    />
                </Form.Group>
                :
                null
            }
        </>
    );
}

export default RetainerUploadComponent;
